var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-view"},[_c('InternalHeader',[_c('div',{staticClass:"c-internal-header__title",attrs:{"slot":"title"},slot:"title"},[_vm._v(" Subscription ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }